/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./InvestmentAnalysis.vue?vue&type=template&id=ea88edb4&scoped=true&"
import script from "./InvestmentAnalysis.vue?vue&type=script&lang=js&"
export * from "./InvestmentAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentAnalysis.vue?vue&type=style&index=0&id=ea88edb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea88edb4",
  null
  
)

export default component.exports